import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthLayout } from '../../layouts/AuthLayout';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Checkbox } from '../../components/ui/Checkbox';
export function Login() {
  const {
    login,
    loading,
    session,
    restoring
  } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Al volver desde el enlace de confirmación del correo, Supabase ya deja
  // la sesión iniciada: se entra directamente al CRM.
  useEffect(() => {
    if (session) navigate('/app/dashboard', {
      replace: true
    });
  }, [session, navigate]);
  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (loading) return;
    setError(null);
    try {
      await login(email, password);
      navigate('/app/dashboard');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se ha podido iniciar sesión.');
    }
  }
  return <AuthLayout title="Inicia sesión" subtitle="Accede al CRM privado de tu empresa." footer={<div className="flex flex-col gap-2 text-muted-foreground" data-id="element-1740" data-mp="19t7r9vx8m1vi">
          <Link to="/recuperar-contrasena" className="font-medium hover:text-foreground" data-id="element-1741" data-mp="1epy4mbhnqjd8">
            ¿Has olvidado tu contraseña?
          </Link>
          <span data-id="element-1742" data-mp="1nrfhzm3ok6y8">
            ¿No tienes cuenta?{' '}
            <Link to="/registro" className="font-medium text-primary hover:underline" data-id="element-1743" data-mp="1nrp95d0gok5i">
              Crear una cuenta
            </Link>
          </span>
        </div>} data-id="element-1739" data-mp="19reh46nf0zir">
      <form onSubmit={handleSubmit} className="space-y-5" noValidate data-id="element-1744" data-mp="3pjc57sz7n58u">
        <Input id="email" label="Email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} data-id="element-1745" data-mp="3uhm1y80l2dwk" />
        <Input id="password" label="Contraseña" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} data-id="element-1746" data-mp="3mg620r2z548l" />
        <Checkbox id="remember" label="Recordarme" checked={remember} onChange={e => setRemember(e.target.checked)} data-id="element-1747" data-mp="3ihp3gvxmd22s" />
        {error && <p role="alert" className="rounded-md bg-red-50 px-4 py-3 text-sm font-medium text-red-700" data-id="element-1748" data-mp="3rfhis03cc9q6">
            {error}
          </p>}
        <Button type="submit" size="lg" loading={loading} className="w-full" data-id="element-1749" data-mp="98uscacv2wh4">
          Iniciar sesión
        </Button>
      </form>
    </AuthLayout>;
}